<template>
  <div>
    <h1 class="admin-title">
      Programs
      <el-button
        style="float:right;"
        size="small"
        @click="showDialog=true"
        type="primary"
      >New Program</el-button>
    </h1>
    <div class="admin-container">
      <el-table v-loading="loading" :data="programs" style="width: 100%">
        <el-table-column prop="attributes.title" label="Program"/>
        <el-table-column label="Actions" width="115">
          <template slot-scope="scope">
            <el-dropdown>
              <el-button type="primary" @click="handleEdit(scope.$index, scope.row)">
                <i class="el-icon-edit"></i> Edit<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleDelete(scope.$index, scope.row)"><i class="el-icon-delete"></i> Delete</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :title="program.id === '' ? 'Add new Program' : 'Edit Program'"
      :visible.sync="showDialog"
      width="500px"
    >
      <el-form>
        <el-form-item label="Program">
          <el-input v-model="program.title"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">Cancel</el-button>
        <el-button type="primary" @click="saveOption">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$nextTick(function() {
      this.getPrograms();
    });
  },
  data() {
    return {
      loading: true,
      showDialog: false,
      programs: [],
      savingData: false,
      program: {
        id: "",
        title: ""
      }
    };
  },
  watch: {
    showDialog(val) {
      if (!val) {
        this.program = {
          id: "",
          title: ""
        };
      }
    }
  },
  methods: {
    getPrograms() {
      var postQuery = new Parse.Query("Programs");
      postQuery
        .find()
        .then(results => {
          this.programs = results;
          this.loading = false;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    goToSignup() {
      this.$router.push("/signup/plan");
    },
    newPost() {
      this.$router.push("/admin-panel/content/form");
    },
    handleEdit(index, row) {
      this.program = {
        id: row.id,
        title: row.attributes.title
      };
      this.showDialog = true
    },
    handleDelete(index, row) {
      row.destroy().then(res => {
        this.$message({
          message: 'Program has been deleted',
          type: 'success'
        });
        this.getPrograms();
      }).catch(err => {
        this.$message({
          message: 'Could not to delete program',
          type: 'error'
        });
      })
    },
    saveOption() {
      var Programs = Parse.Object.extend("Programs");
      var program = new Programs();
      program
        .save(this.program)
        .then(res => {
          this.$message({
            message: this.program.id === ''? 'Program has been created' : 'Program has been updated',
            type: 'success'
          });
          this.getPrograms();
          this.showDialog = false;
        })
        .catch(err => {
          this.showDialog = false;
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.article-container .main-image {
  height: 300px;
  background-size: cover;
}
.article-container h1 {
  width: 100%;
  text-align: left;
  padding: 20px 30px 5px;
  margin: 0;
  color: #666;
}
.article-body {
  padding: 0 30px;
  text-align: left;
  margin-bottom: 30px;
}
.article-body p{
  margin: 5px 0 10px;
  color: #999;
  line-height: 26px;
}
.el-table .cell{
  text-align: left;
}
.el-table .cell h3 {
  font-size: 14px;
}
.el-table .cell p {
  font-size: 12px;
  color: #999;
}
</style>